const DEFAULT_ITEMS = [
  "Three-Phase Electrical",
  "Residential",
  "Commercial",
  "Industrial",
  "Fiber Optics",
  "Wiring & Rewiring",
  "Troubleshooting",
  "Structured Cabling",
];

export const Marquee = ({ items = DEFAULT_ITEMS, testId = "marquee-strip" }) => {
  const row = [...items, ...items];
  return (
    <div className="marquee-paused overflow-hidden border-t border-[#1E293B] bg-[#0B0F19] py-5" data-testid={testId}>
      <div className="animate-marquee flex w-max items-center">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="whitespace-nowrap px-8 font-display text-2xl font-semibold uppercase tracking-wide text-[#1E293B] transition-colors duration-300 hover:text-[#FF5B00] sm:text-3xl">
                  {item}
                </span>
                <span className="h-2 w-2 rotate-45 bg-[#FF5B00]" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
